<template>
  <div class="contacts">
    <FaqAndSupportContactsCardLink
      :label="'Найдите ответ'"
      :text="'База знаний'"
      :link="'https://help.mts-link.ru/'"
      class="contacts__item"
    />
    <FaqAndSupportContactsCardLink
      :label="'Проверьте'"
      :text="'Состояние сервиса'"
      :link="'https://status.mts-link.ru/'"
      class="contacts__item"
    />
    <PhoneDisclaimer>
      <FaqAndSupportContactsCard
        :label="'Звоните по любому номеру'"
        :with-hover="false"
        class="contacts__item contacts__item--phone"
      >
        <template #content>
          <div class="contacts__item-links">
            <a href="tel:+78005510669">
              <VIconMTS
                name="faq_and_support/icon-phone"
                width="44"
                height="44"
              />
              <span>8 (800) 551-06-69</span>
            </a>
            <a href="tel:+74951470663">
              <VIconMTS
                name="faq_and_support/icon-phone"
                width="44"
                height="44"
              />
              <span>8 (495) 147-06-63</span>
            </a>
          </div>
        </template>
      </FaqAndSupportContactsCard>
    </PhoneDisclaimer>
    <FaqAndSupportContactsCardWithCopy
      :label="'Пишите на почту'"
      :text="'support@mts-link.ru'"
      :text-to-copy="'support@mts-link.ru'"
      class="contacts__item"
    />
  </div>
</template>

<script>
import FaqAndSupportContactsCardWithCopy from '@/components/Desktop/FaqAndSupport/Contacts/FaqAndSupportContactsCardWithCopy.vue'
import FaqAndSupportContactsCardLink from '@/components/Desktop/FaqAndSupport/Contacts/FaqAndSupportContactsCardLink.vue'
import FaqAndSupportContactsCard from '@/components/Desktop/FaqAndSupport/Contacts/FaqAndSupportContactsCard.vue'
import VIconMTS from '@/components/Common/MTS/VIconMTS.vue'
import PhoneDisclaimer from '@/components/NewDesign/Common/UI/PhoneDisclaimer/PhoneDisclaimer.vue'

export default {
  name: 'FaqAndSupportContacts',
  components: {
    PhoneDisclaimer,
    VIconMTS,
    FaqAndSupportContactsCard,
    FaqAndSupportContactsCardLink,
    FaqAndSupportContactsCardWithCopy,
  },
}
</script>

<style scoped lang="scss">
.contacts {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 16px;

  @include screen-down(1281px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @include screen-down('md') {
    grid-template-columns: 1fr;
    margin-bottom: 32px;
  }

  &__item {
    &--phone {
      .contacts__item-links {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
        margin-top: auto;
      }

      a {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 4px;
        border-radius: 12px;
        color: $color-dark-2;
        text-decoration: none;
        transition: background-color 0.3s;

        &:hover {
          @media (hover) {
            background-color: #bcc3d040;
          }
        }

        svg {
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>
